import { useAuth } from '../../context/AuthContext';
import { FOUNDING_OWNER_ID } from '../../utils/constants';

const FEATURES = [
  { label: 'Staff Management', free: true, premium: true },
  { label: 'Clock-In Panel', free: true, premium: true },
  { label: 'Shift Tracking', free: true, premium: true },
  { label: 'Basic Payroll', free: true, premium: true },
  { label: 'Rank System', free: true, premium: true },
  { label: 'Audit Logs', free: true, premium: true },
  { label: 'Bonus System', free: '3/month', premium: 'Unlimited' },
  { label: 'Dashboard Admins', free: '2 max', premium: 'Unlimited' },
  { label: 'Holiday Bonuses', free: false, premium: true },
  { label: 'Scheduled Bonuses', free: false, premium: true },
  { label: 'Priority Support', free: false, premium: true },
  { label: 'Custom Branding', free: false, premium: 'Coming soon' },
  { label: 'API Access', free: false, premium: 'Coming soon' },
];

export default function SubscriptionPage({ guild }) {
  const { user } = useAuth();
  const isOwner = user?.discord_id === FOUNDING_OWNER_ID;

  return (
    <div style={{ maxWidth: '800px' }}>
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '32px', color: 'var(--text-primary)', marginBottom: '6px' }}>Subscription</h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '15px' }}>{guild.name}</p>
      </div>

      {/* Current plan */}
      <div style={{
        background: 'var(--gradient-accent)', borderRadius: '20px', padding: '28px',
        marginBottom: '28px', color: '#fff',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      }}>
        <div>
          <div style={{ fontSize: '13px', opacity: 0.85, marginBottom: '6px', fontWeight: 600 }}>CURRENT PLAN</div>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: '32px', fontWeight: 900, marginBottom: '6px' }}>
            {guild.activated ? 'Active' : 'Free'}
          </div>
          <div style={{ fontSize: '14px', opacity: 0.85 }}>
            {guild.activated ? 'Your server is activated and running.' : 'Activate your server with a license key to unlock all features.'}
          </div>
        </div>
        <div style={{ fontSize: '60px' }}>
          {guild.activated ? '⭐' : '🔓'}
        </div>
      </div>

      {/* Feature comparison */}
      <div style={{
        background: 'var(--bg-card)', border: '1px solid var(--border)',
        borderRadius: '16px', overflow: 'hidden', boxShadow: 'var(--shadow-card)',
        marginBottom: '24px',
      }}>
        <div style={{
          display: 'grid', gridTemplateColumns: '2fr 1fr 1fr',
          padding: '14px 20px', background: 'var(--bg-secondary)',
          borderBottom: '1px solid var(--border)',
          fontSize: '13px', fontWeight: 700, color: 'var(--text-secondary)',
        }}>
          <span>Feature</span>
          <span style={{ textAlign: 'center' }}>Free</span>
          <span style={{ textAlign: 'center', color: 'var(--accent-primary)' }}>Premium ⭐</span>
        </div>
        {FEATURES.map(f => (
          <div key={f.label} style={{
            display: 'grid', gridTemplateColumns: '2fr 1fr 1fr',
            padding: '12px 20px', borderBottom: '1px solid var(--border)',
            transition: 'background 0.15s',
          }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-secondary)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            <span style={{ fontSize: '14px', color: 'var(--text-primary)' }}>{f.label}</span>
            <span style={{ textAlign: 'center', fontSize: '14px' }}>
              {f.free === true ? <span style={{ color: 'var(--success)' }}>✓</span>
                : f.free === false ? <span style={{ color: 'var(--text-muted)' }}>—</span>
                  : <span style={{ color: 'var(--text-secondary)', fontSize: '12px' }}>{f.free}</span>}
            </span>
            <span style={{ textAlign: 'center', fontSize: '14px' }}>
              {f.premium === true ? <span style={{ color: 'var(--success)' }}>✓</span>
                : f.premium === false ? <span style={{ color: 'var(--text-muted)' }}>—</span>
                  : <span style={{ color: 'var(--accent-primary)', fontSize: '12px', fontWeight: 600 }}>{f.premium}</span>}
            </span>
          </div>
        ))}
      </div>

      {/* Coming soon note */}
      <div style={{
        background: 'var(--bg-secondary)', border: '1px solid var(--border)',
        borderRadius: '14px', padding: '20px 24px',
        fontSize: '14px', color: 'var(--text-secondary)', lineHeight: 1.6,
      }}>
        <strong style={{ color: 'var(--text-primary)' }}>💡 Premium coming soon.</strong>{' '}
        Paid plans are in development. All features are currently available to activated servers.
        {isOwner && ' As the owner, you have full access to all features.'}
      </div>
    </div>
  );
}
